import React, { useEffect, useState } from 'react'
import { INITIAL_VALUES, toFormValues } from './form'
import { useErrorHandling } from 'context/errorHandling'
import { SuccessDialog } from 'components/Shared/Dialogs'
import { useTranslation } from 'react-i18next'
import CustomFieldsForm from 'components/CustomFields/CustomFieldsForm/CustomFieldsForm'
import { fetchCustomField, updateCustomField } from 'services/CustomFieldService'
import { useNavigatePrevent } from 'context/navigatePrevent'

export function CustomFieldsEditForm (props) {
  const customFieldId = props.match.params.id

  const [successDialogOpen, setSuccessDialogOpen] = useState(false)
  const [initialValues, setInitialValues] = useState(INITIAL_VALUES)

  const { t } = useTranslation()
  const { handleError } = useErrorHandling()
  const { setNavigationUnlocked } = useNavigatePrevent()

  useEffect(() => {
      fetchCustomField(customFieldId)
        .then(customField => {
          const formValues = toFormValues(customField)
          return setInitialValues(formValues)
        })
        .catch(handleError)
    }, [customFieldId, handleError]
  )

  const handleSubmit = values => {
    updateCustomField(customFieldId, values)
      .then(() => setSuccessDialogOpen(true))
      .catch(handleError)
  }

  const handleSuccessDialogClose = () => {
    setSuccessDialogOpen(false)
    setNavigationUnlocked(history => history.push('/custom-fields'))
  }

  return (
    <>
      <SuccessDialog
        content='customField.form.edit.onSuccessMessage'
        open={successDialogOpen}
        onClose={handleSuccessDialogClose}
      />
      <CustomFieldsForm
        onSubmit={handleSubmit}
        initialValues={initialValues}
        title={t('customField.form.edit.title')}
        isEditForm
      />
    </>
  )
}
